/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Checks if a string can be converted to a valid number
 * @param value - The string to check
 * @returns boolean indicating if the string can be converted to a number
 */
export const isStringNumber = (value: any): boolean => {
  if (typeof value !== "string") {
    return false;
  }

  return !Number.isNaN(Number(value)) && !Number.isNaN(parseFloat(value));
};
